import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConnectService } from '../connect.service';


@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.css']
})
export class ConnectComponent implements OnInit {

  public finished: boolean;
  public error:string;

  // public showConnect = ()=> this.connectService.show;
  // public close = () => this.connectService.toggleConnect(false); 
  public close() {
    this.connectService.toggleConnect(false);
  }


  public form: any;

  public submit(form) {
    if (!(form.name && form.email && form.phone && form.referral && form.inquiry)) {
      this.error = "Please fill out all fields.";
        setTimeout(() => {
          this.error = null;
        }, 1000);
      return;
    }
    if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(form.email))) {
      this.error = "Please enter a valid email address.";
        setTimeout(() => {
          this.error = null;
        }, 1000);
      return;
    }
    if (form.inquiry && (form.inquiry === 'dealer' || form.inquiry === 'builder') && !(form.company && form.state && form.position)) {
      this.error = "Please tell us about you and your company";
        setTimeout(() => {
          this.error = null;
        }, 1000);
      return;
    }
    this.connectService.submit(form);
    console.log("FORM: ", form);
    this.finished = true;


  }

  public selectInquiry(val: string) {

    this.form.inquiry = val;
    console.log("Form: ", this.form);
  }

  // public step = 0;

  // public questions = [
  //   {
  //     label: "My name is",
  //     model: "",
  //     type: "text"
  //   },
  //   {
  //     label: "My email is",
  //     model: "",
  //     type: "text"
  //   },
  //   {
  //     label: "I'm interested in",
  //     model: "",
  //     type: ""
  //   },
  //   {
  //     label: "What do you want to talk about?",
  //     model: "",
  //     type: "text"
  //   },
  //   {
  //     label: "Thanks for reaching out! We'll get back to you soon.",
  //     model: null,
  //     type: "thanks"
  //   }
  // ];

  // incrementStep(){
  //   this.step++;
  // }

  constructor(public connectService: ConnectService) { }

  ngOnInit() {
    this.form = {};
  }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/connect/connect.component.ts